// extracted by mini-css-extract-plugin
export default {"tagContainer":"styles_tagContainer__Jzmyk","hover":"styles_hover__sLlNA","tag":"styles_tag__JhiCY"};